export default (initialState, reducers) => (
    state = initialState,
    action,
    shared
) => {
    if (Object.prototype.hasOwnProperty.call(reducers, action.type)) {
        return reducers[action.type](state, action, shared);
    } else {
        return state;
    }
};
